import { render, staticRenderFns } from "./Rating.vue?vue&type=template&id=2a3053a5&scoped=true"
import script from "./Rating.vue?vue&type=script&lang=js"
export * from "./Rating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3053a5",
  null
  
)

export default component.exports